import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { globalVariables } from "../../../../global/GlobalVariables";

function getOrgType(org) {
  if (org) {
    const orgTypes = org?.organizationTypes;

    if (orgTypes?.club) {
      return "Gaming Club";
    } else if (orgTypes?.store) {
      return "Game Store";
    } else if (orgTypes?.publisher) {
      return "Publisher";
    } else if (orgTypes?.tournamentOrganizer) {
      return "Independent Tournament Organizer";
    } else {
      return "Organization";
    }
  } else {
    return "Organization";
  }
}

export default function OrganizationHelmet(props) {
  const globalVars = globalVariables();

  const { organization } = props;
  const [title, setTitle] = useState(
    `${getOrgType(organization)} | ${globalVars.site.title}`
  );
  const [description, setDescription] = useState(globalVars.site.description);
  const [image, setImage] = useState(globalVars.site.logo);
  const url = window.location.href;

  useEffect(() => {
    // Set title
    if (organization?.name && organization?.name !== "") {
      setTitle(`${organization.name} | ${globalVars.site.title}`);
    }

    // Set description
    if (organization?.description && organization?.description !== "") {
      const trimmedDesc = trimDescription(organization?.description, 123);

      setDescription(trimmedDesc);
    }

    // Set Image
    if (organization?.photoUrl) {
      setImage(organization.photoUrl);
    }

    // eslint-disable-next-line
  }, [organization]);

  const trimDescription = (desc, length) => {
    desc = desc.replace(/\n/g, " ");
    desc = desc.replace(/\s\s+/g, " ");
    if (desc.length <= length) {
      return desc;
    }

    let trimmedString = desc.substr(0, length);

    trimmedString = trimmedString.substr(
      0,
      Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))
    );
    trimmedString += "...";

    return trimmedString;
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta property="title" content={title} />
      <meta property="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:alt" content={`Image for: ${title}`} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
    </Helmet>
  );
}
